import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";

const ViewErpData = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    const formatINR = (value) => {
        if (!value && value !== 0) return "N/A";
        return Number(value).toLocaleString("en-IN");
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    View ERP Data
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: "3px",
                        border: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        p: 2,
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                        <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                            ERP Data Details
                        </Typography>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <CardContent sx={{ pt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Work Category:</Typography>
                                <Typography sx={valueStyle}>{rowData?.workCategory || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Sub Category:</Typography>
                                <Typography sx={valueStyle}>{rowData?.subCategory || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Work Order Number:</Typography>
                                <Typography sx={valueStyle}>{rowData?.workOrderNumber || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Work Order Status:</Typography>
                                <Typography sx={valueStyle}>{rowData?.workOrderStatus || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Contractor Name:</Typography>
                                <Typography sx={valueStyle}>{rowData?.contractorName || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Work Order Value:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.workOrderValue)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Certificate Type:</Typography>
                                <Typography sx={valueStyle}>{rowData?.certificateType || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Invoice No:</Typography>
                                <Typography sx={valueStyle}>{rowData?.invoiceNo || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Invoice Date:</Typography>
                                <Typography sx={valueStyle}>
                                    {rowData?.invoiceDate ? moment(rowData.invoiceDate).format("DD MMM YYYY") : "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Due Date:</Typography>
                                <Typography sx={valueStyle}>
                                    {rowData?.dueDate ? moment(rowData.dueDate).format("DD MMM YYYY") : "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Certificate No:</Typography>
                                <Typography sx={valueStyle}>{rowData?.certificateNo || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Creation Date:</Typography>
                                <Typography sx={valueStyle}>
                                    {rowData?.creationDate ? moment(rowData.creationDate).format("DD MMM YYYY") : "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Processed Date:</Typography>
                                <Typography sx={valueStyle}>
                                    {rowData?.processedDate ? moment(rowData.processedDate).format("DD MMM YYYY") : "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Status:</Typography>
                                <Typography sx={valueStyle}>
                                    {rowData?.status ? <StatusBadge status={rowData.status} /> : "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Certified Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.certifiedAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Discount Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.discountAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Base Certified Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.baseCertifiedAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Tax Addition (Inclusive):</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.taxAdditionInclusive)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Tax Addition (Exclusive):</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.taxAdditionExclusive)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Material Escalation:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.materialEscalation)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Gross Bill Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.grossBillAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Advance Adj. Recovered:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.advanceAdjRecovered)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Misc Adj. Recovered:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.miscAdjRecovered)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Material Adj Recovered:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.materialAdjRecovered)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Debit Note Adj. Recovered:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.debitNoteAdjRecovered)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Tax Deduction:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.taxDeduction)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Retention Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.retentionAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Other Deduction:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.otherDeduction)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Cheque.No/ Cheque.Dt:</Typography>
                                <Typography sx={valueStyle}>{rowData?.chequeNoOrDetails || "-"}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Cheque Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.chequeAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Amount Payable:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.amountPayable)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Amount Paid:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.amountPaid)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Outstanding Amount:</Typography>
                                <Typography sx={valueStyle}>{formatINR(rowData?.outstandingAmount)}</Typography>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                <Typography sx={labelStyle}>Remarks:</Typography>
                                <Typography sx={valueStyle}>{rowData?.remarks || "-"}</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default ViewErpData;